<template>
    <div class="base-mit-volume-analytics-time">
        <v-card flat>
            <v-card-title class="text-h5"><v-icon class="pr-1">{{icon}}</v-icon>{{title}}</v-card-title>
            <v-card-subtitle v-if="subTitle.length > 0">{{subTitle}}</v-card-subtitle>
            <v-row class="pa-4" justify="space-between">
                <v-col cols="12">
                    <v-card flat>
                        <canvas id="timeseries"></canvas>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
// import Chart from 'chart.js/auto';
// import moment from 'moment';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';


export default {
  name: 'MitVolumesAnalyticsTime',
  components: {
  },
  props: {
      title:{
          default:'Volume Analytics',
          type:String
      },
      subTitle:{
          default:'',
          type:String
      },
      icon:{
          default:'',
          type:String
      },
    timeseriesActivity: {
      default: {
          datasets:null,
          title:'title',
          labelX:'',
          labelY:''
      },
      type: Object
    }
  },
  data: function() {
    return {
        colors:['rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)']
    }
  },
  created() {
  },
  mounted() {

      this.timeseriesActivity.datasets.forEach((ds, index, arr)=>{
          ds.borderColor = this.colors[index];
          ds.backgroundColor = this.colors[index];
      });

    const ctxLine = document.getElementById('timeseries');
    var chart = new Chart(ctxLine, {
      type: 'line',
      data: { datasets: this.timeseriesActivity.datasets },
      options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: this.timeseriesActivity.title
            }
          },
          scales: {
              x: {
                type: 'time'
              }
          }
      }
    });


  },
  methods : {
    nodeClicked(node){

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
